export class BreakPoint {
  public static JigyoshoSearchSPMaxWidth = 899;
  public static JigyoshoDetailSPMaxWidth = 989;
  public static PCMax = 1080;

  public static jigyoshoSearchIsSP(): boolean {
    return this.windowWidth() <= this.JigyoshoSearchSPMaxWidth;
  }

  public static jigyoshoSearchIsPC(): boolean {
    return !this.jigyoshoSearchIsSP();
  }

  public static isPCSmallMin(): boolean {
    return this.windowWidth() >= this.PCSmallMin;
  }

  public static isSP(): boolean {
    return !this.isPCSmallMin();
  }

  public static isPCMax(): boolean {
    return this.windowWidth() >= this.PCMax;
  }

  private static PCSmallMin = 769;

  private static windowWidth(): number {
    return window.innerWidth;
  }
}
